import React from "react";
import JalRoLayout from "../components/JalRoLayout";
import {
  ContactCtaSection,
  FaqSection,
  HeroSection,
  ProcessSection,
  ProductsSection,
  ReviewsSection,
  ServiceAreasSection,
  ServicesSection,
  WhyChooseUsSection,
} from "../components/JalRoSections";

const HomePageOne = () => (
  <JalRoLayout>
    <HeroSection />
    <WhyChooseUsSection />
    <ServicesSection />
    <ProductsSection />
    <ProcessSection />
    <ReviewsSection />
    <ServiceAreasSection />
    <FaqSection />
    <ContactCtaSection />
  </JalRoLayout>
);

export default HomePageOne;
